import { render, staticRenderFns } from "./SupplierLedgerSettingsModal.vue?vue&type=template&id=9b21fa20&scoped=true&"
import script from "./SupplierLedgerSettingsModal.vue?vue&type=script&lang=js&"
export * from "./SupplierLedgerSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./SupplierLedgerSettingsModal.vue?vue&type=style&index=0&id=9b21fa20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b21fa20",
  null
  
)

export default component.exports